import styled from 'styled-components';

export const CarCounterContainer = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const CarCounterWrapper = styled.div`
    display: flex;
    flex-direction: column;

    > Label:last-child {
        margin-top: 4px;
    }
`;

export const CountWrapper = styled.div`
    width: 100%;
    max-width: 113px;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const CountBtnWrapper = styled.div`
    width: 32px;
    height: 32px;
    
    button {
        position: relative;
    }

    svg {
        position: absolute;
        left: 0;
        top: 0;
        border-radius: 8px;
    }
`;